$(document.body).on('updated_cart_totals', function() {
    console.log('updated cart');
    window.dispatchEvent(
        new CustomEvent('addedToCart', { detail: { disablePopup: true } }),
    );
});
